"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _NestedFlipTiles = _interopRequireDefault(require("./NestedFlipTiles.scss"));

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _StringHelper = _interopRequireDefault(require("../../../helpers/StringHelper"));

var MAX_COLOR_COUNT = 7; // this is the number of colors defined in css

var keyColorMapping = {};

function getColorByIndex(index) {
  return {
    backgroundClass: _NestedFlipTiles["default"]["background-color".concat(index)],
    glowClass: _NestedFlipTiles["default"]["background-glow".concat(index)]
  };
}

function getIndexByString(str, maxColorCount) {
  return (Math.abs(_StringHelper["default"].getDjb2HashCode(str)) + 1) % maxColorCount + 1;
}

var TilesColorHelper = /*#__PURE__*/function () {
  function TilesColorHelper() {
    (0, _classCallCheck2["default"])(this, TilesColorHelper);
  }

  (0, _createClass2["default"])(TilesColorHelper, null, [{
    key: "getColorFromKey",

    /**
     * Returns the colors for the given key. In case no keyword is available, it uses the id.
     * Same keyword/id always leads to same color.
     */
    value: function getColorFromKey(key, id) {
      var maxColorCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : MAX_COLOR_COUNT;
      var index = getIndexByString(key || id, maxColorCount);

      if (!keyColorMapping[index]) {
        keyColorMapping[index] = getColorByIndex(index);
      }

      return keyColorMapping[index];
    }
  }]);
  return TilesColorHelper;
}();

(0, _defineProperty2["default"])(TilesColorHelper, "getMatchingLectureHeaderTextColorToBackgroundColor", function (backgroundColor) {
  if (!backgroundColor) {
    return _cssConstants["default"].colors.lectureHeaderText;
  }

  if (_cssConstants["default"].colorMap) {
    var backgroundColorToCheck = backgroundColor.toUpperCase();

    if (_cssConstants["default"].colorMap[backgroundColorToCheck]) {
      return _cssConstants["default"].colorMap[backgroundColorToCheck];
    } else {
      return _cssConstants["default"].colors.lectureHeaderText;
    }
  }
});
var _default = TilesColorHelper;
exports["default"] = _default;